import { StringifyOptions } from 'querystring';
import styled, { CSSProperties } from 'styled-components';
import { colorOpacity, colorShade } from '../../utils/style';

interface ProgressCircularProps {
    value?: number | 'indeterminate';
    thickness?: number;
    color?: string;
    size?: number | string;
    className?: string;
}

const SIZE = 40;

export default function ProgressCircular({ thickness = 6, value = 0, color, size = 40, className }: ProgressCircularProps) {
    return (
        <Wrapper style={{ width: size, height: size }} className={`${className} ${value === 'indeterminate' ? 'animate' : ''}`} color={color}>
            <svg className="circular-progress-svg" viewBox={`${-SIZE / 2} ${-SIZE / 2} ${SIZE} ${SIZE}`} overflow='visible'>
                <circle className="circular-progress-svg-circle-background" cx="0" cy="0" r={SIZE / 2} fill="none" strokeWidth={thickness / 2}></circle>
                <circle style={value !== 'indeterminate' ? { strokeDasharray: `${value / 100 * SIZE * Math.PI}px, 200px`, strokeDashoffset: '0px', transform: 'rotate(90deg)' } : {}} className="circular-progress-svg-circle" cx="0" cy="0" r={SIZE / 2} fill="none" strokeWidth={thickness}></circle>
            </svg>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    &.animate {
        .circular-progress-svg {
            animation: circularRotateKeyframe 2s infinite linear;
        }
        .circular-progress-svg-circle {
            animation: circularDashKeyframe 1.5s infinite linear;
        }
    }

    .circular-progress-svg {
        display: block;
        transform-origin: center;
    }

    .circular-progress-svg-circle {
        color: ${props => props.color || props.theme.primaryColor};
        stroke: currentColor;
        transition: stroke-dasharray 0.4s;
    }

    .circular-progress-svg-circle-background {stroke: ${props => colorOpacity(props.color || props.theme.primaryColor, 0.3)}}
    @keyframes circularRotateKeyframe {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    @keyframes circularDashKeyframe {
        0% { stroke-dasharray: 1px, 200px; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -15px; }
        100% { stroke-dasharray: 100px, 200px; stroke-dashoffset: -125px; }
    }
    
`